import { Component, HostBinding, Input } from "@angular/core";

import { IWidget, PageEvent } from "../../../../../manager/widgets/i-widget";
import { WizEventManager } from "@wizeoo/akm-component-lib";
import { ALK_EVENT_TYPE, PAGE_EVENT_KIND, PAGE_EVENT_SYMBOL } from "../../../../../model/enums";
import { AlkEvent } from "../../../../../framework/events/alk.event";

/**
 * rendu d'une ligne de style
 */
@Component({
  selector: 'compute-page',
  templateUrl: './compute-page.html',
})
export class ComputePageRenderer {
  @HostBinding('style.width') forcedWidth = '26px';

  // le widget d'origine
  @Input() public widget: IWidget;
  // un symbole pour la navigation "extrême"
  @Input() public symbol: PAGE_EVENT_SYMBOL = null;
  // une page
  @Input() public page: number;

  /**
   * génère le libellé, soit le symbole, soit la page
   */
  public get pageOrSymbol(): string {
    let result: string = this.symbol?.toString() || this.page?.toString();
    // console.log('page s:', result );
    return result
  }

  /**
   * appel html, rendu pour la sélection
   */
  public get background(): string  {
    if(this.amISelected()) { // 
      return '#F58022';
      // return '#fff7fe';
    } 
    return '#FFFFFF';
  }

  /**
   * contrôle si JE suis sélectionné (uniquement les pages, pas les symboles)
   * @returns 
   */
  private amISelected(): boolean {
    let current: number = this.widget.context?.cmp;
    return this.page === current; 
  }

  /**
   * dispatch de l'event de navigation
   */
  public goToPage(): void {
    let current: number = this.widget.context.cmp;

    let pageEvent: PageEvent = null;

    if(this.symbol) {
      
      switch(this.symbol) {
        case PAGE_EVENT_SYMBOL.FIRST:
          pageEvent = {kind: PAGE_EVENT_KIND.ABS, vector: 1};
          break;
        case PAGE_EVENT_SYMBOL.BACK:
          pageEvent = {kind: PAGE_EVENT_KIND.REL, vector: -1};
          break;
        case PAGE_EVENT_SYMBOL.NEXT:
          pageEvent = {kind: PAGE_EVENT_KIND.REL, vector: 1};
          break;
        case PAGE_EVENT_SYMBOL.LAST:
          let maxPage: number = this.widget.model.widgetEngine.widgetMaxPages(this.widget);
          pageEvent = {kind: PAGE_EVENT_KIND.ABS, vector: maxPage};
          break;
      }
    } else {
      if(current !== this.page) {
        pageEvent = {kind: PAGE_EVENT_KIND.ABS, vector: this.page};
      }
    }

    if(pageEvent) {
      WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_GET, pageEvent));    
    }
  }

}

